// Generic modal opener/closer using native <dialog>
document.querySelectorAll('[data-modal-open]').forEach(trigger => {
  trigger.addEventListener('click', () => {
    const id = trigger.dataset.modalOpen;
    const modal = document.getElementById(id);
    if (modal && typeof modal.showModal === 'function') modal.showModal();
  });
});
document.querySelectorAll('[data-modal-close]').forEach(btn => {
  btn.addEventListener('click', () => {
    const modal = btn.closest('[data-modal]');
    if (modal && typeof modal.close === 'function') modal.close();
  });
});
